import Navbar from 'src/components/HorizontalLayout/Navbar';
import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom";
import {
    Card,
    CardBody,
    CardTitle,
    CardHeader,
    Col,
    Container,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    Label,
    Button,
    Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Nav, NavItem, TabPane, TabContent, NavLink
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useAgency } from 'src/components/Common/agencyBrandingData';
import { setAgencySuccessful, setAgencyFailed } from "src/slices/Auth/Agency/reducer";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { toast } from 'react-toastify';
import axiosInstance from "src/common/axiosInstance";
import { setAgency } from "src/slices/thunks";
import {
    changeLayout,
    changeLayoutWidth,
    changeLayoutPosition,
    changelayoutMode,
    changeTopbarTheme,
    changeSidebarType,
    changeSidebarTheme,
} from "../../slices/Layout/thunk";
//constants
import {
    layoutTypes,
    layoutTheme,
    layoutWidthTypes,
    layoutPositions,
    topBarThemeTypes,
    leftSidebarTypes,
    leftSideBarThemeTypes,
} from "../../constants/layout";

import { createSelector } from "reselect";
import { useLocation } from 'react-router-dom';
import CorporateInfo from './CorporateInfo';
import { usePageAccess, PAGE_ACCESS_TYPES } from '../../components/Common/useAuthRedirect';
const Branding = () => {
    type FormDataType = typeof formData;
    const agency = useAgency();
    const [menu, setMenu] = useState(false);
    const [menu1, setMenu1] = useState<boolean>(false);
    const [activeTab, setActiveTab] = useState<string>("1");
    const [isEditing, setIsEditing] = useState(false); // Moved inside component
    const navigate = useNavigate();
    const location = useLocation();
    const agencyData = useSelector((state: any) => state.agency.agency.data);
    const toggleTab = (tab: any) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    const dispatch = useDispatch();
    const [bodyBg, setBodyBg] = useState("");
    const [loading, setLoading] = useState(false);
    const [inputKey, setInputKey] = useState(Date.now());
    const [formData, setFormData] = useState({
        agency_name: agency.data.agency_name,
        agency_desc: agency.data.agency_desc,
        agency_domain: agency.data.agency_domain,
        agency_logo: null,
        layout_theme: agency.data.layout_theme || layoutTheme.LIGHTMODE,
        topbar_theme: agency.data.topbar_theme || topBarThemeTypes.LIGHT,
    });
    const [originalFormData, setOriginalFormData] = useState<FormDataType>(formData);
    const { user, userError } = useSelector((state: any) => state.login);

    const selectLayoutProperties = createSelector(
        (state: any) => state.Layout,
        (layout: any) => ({
            layoutType: layout.layoutType,
            layoutMode: layout.layoutMode,
            layoutWidth: layout.layoutWidth,
            layoutPosition: layout.layoutPosition,
            topbarTheme: layout.topbarTheme,
            leftSideBarType: layout.leftSideBarType,
            leftSideBarTheme: layout.leftSideBarTheme,
        })
    );

    const {
        layoutType,
        layoutMode,
        layoutWidth,
        layoutPosition,
        topbarTheme,
        leftSideBarType,
        leftSideBarTheme,
    } = useSelector(selectLayoutProperties);

    usePageAccess(PAGE_ACCESS_TYPES.ADMIN_SPECIFIC_ONLY);

    const getEnvDomainSuffix = () => {
        const env = process.env.REACT_APP_ENV; // local | staging | production

        if (env === "local") return ".local";
        if (env === "staging") return ".staging";
        return ""; // production
    };
    const subDomain = agency?.data?.agency_domain || "q1media";
    const envSuffix = getEnvDomainSuffix();
    const fullDomain = `${subDomain}${envSuffix}.unifieddatastudio.com`;

    useEffect(() => {
        const bg = getComputedStyle(document.body).getPropertyValue('--bs-body-bg').trim();
        setBodyBg(bg);
    }, [agency.data.layout_theme, agency.data.topbar_theme]);

    //on unmount or route change, revert to persisted themes
    useEffect(() => {
        const handleBeforeUnloadOrRouteChange = () => {
            const agencyInfo = JSON.parse(localStorage.getItem("agencyInfo") || '{}');
            const storedLayoutTheme = agencyInfo.data?.layout_theme || layoutTheme.LIGHTMODE;
            const storedTopbarTheme = agencyInfo.data?.topbar_theme || 'light';

            dispatch(changelayoutMode(storedLayoutTheme, layoutType));
            dispatch(changeTopbarTheme(storedTopbarTheme));

        };

        // Listen on unmount
        return () => {
            handleBeforeUnloadOrRouteChange();
        };
    }, [location.pathname]); // Rerun when route changes

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        // Check if the event target is an input element of type 'file'
        if (e.target.type === 'file') {
            const { files } = e.target;

            if (files && files[0]) {
                const file = files[0];
                const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
                if (!allowedTypes.includes(file.type)) {
                    toast.error("Invalid file type. Only JPG,JPEG and PNG are allowed.");
                    setFormData({ ...formData, agency_logo: null });
                    setInputKey(Date.now());
                    return;
                }
                // Update state with the file object if a file is selected
                const img = new Image();
                img.src = URL.createObjectURL(file);
                img.onload = () => {
                    const maxWidth = 500;  // Set your required max width
                    const maxHeight = 500; // Set your required max height
                    if (img.width != maxWidth || img.height != maxHeight) {
                        toast.error(`Logo dimensions should be ${maxWidth}x${maxHeight}px.`);
                        setFormData({ ...formData, agency_logo: null });
                        setInputKey(Date.now());
                        return;
                    }
                    // Update state with the valid file
                    setFormData({ ...formData, [name]: file });
                };
            }
        } else {
            // For text fields and textareas, update the state with the value
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleEditClick = () => {
        setOriginalFormData({ ...formData });
        setIsEditing(true);
    };

    const handleCancelClick = () => {
        // Restore original data
        setFormData({ ...originalFormData });
        setIsEditing(false);
        // Reset input key to clear file input
        setInputKey(Date.now());

        // Revert theme changes to original values
        dispatch(changelayoutMode(originalFormData.layout_theme || layoutTheme.LIGHTMODE, layoutType));
        dispatch(changeTopbarTheme(originalFormData.topbar_theme || topBarThemeTypes.LIGHT));
    };

    const handleSaveClick = () => {
        // Trigger form submission
        const form = document.querySelector('form');
        if (form) {
            const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
            form.dispatchEvent(submitEvent);
        }
    };
    const hasDataChanged = () => {
        const fieldsToCompare = ["agency_name", "agency_desc", "agency_domain", "layout_theme", "topbar_theme"];

        for (let field of fieldsToCompare) {
            if (
                formData[field as keyof typeof formData] !==
                originalFormData[field as keyof typeof originalFormData]
            ) {
                return true;
            }
        }

        if (formData.agency_logo) {
            return true;
        }

        return false;
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true);
        const data = new FormData();
        data.append("agency_id", agency.data.Id);
        data.append("agency_name", formData.agency_name);
        data.append("agency_desc", formData.agency_desc);
        data.append("agency_domain", formData.agency_domain);
        data.append("layout_theme", formData.layout_theme || layoutTheme.LIGHTMODE);
        data.append("topbar_theme", formData.topbar_theme || topBarThemeTypes.LIGHT);

        if (formData.agency_logo) {
            data.append("agency_logo", formData.agency_logo);
        }

        const domain = formData.agency_domain ? formData.agency_domain.trim() : '';
        // Allow a-z, 0-9, hyphens, and dots, but disallow double dots, trailing dot, etc.
        const domainRegex = /^[a-z](?:[a-z0-9-]*[a-z])$/;

        const descRegex = /^[a-z](?:[a-z0-9-]*[a-z])$/;

        if (!formData.agency_name || formData.agency_name.trim() === "") {
            toast.error('Agency name can not be empty.');
            setLoading(false);
            return false;
        }

        if (domain === '') {
            toast.error('Agency domain can not be empty.');
            setLoading(false);
            return false;
        }

        if (!domainRegex.test(domain)) {
            toast.error('Invalid domain format. Only lowercase alphanumeric characters ,only hyphens are allowed.');
            setLoading(false);
            return false;
        }

        if (domain.startsWith('-') || domain.endsWith('-')) {
            toast.error('Domain can not start or end with a hyphen.');
            setLoading(false);
            return false;
        }

        if (domain.length > 15) {
            toast.error('Domain should not exceed 15 characters.');
            setLoading(false);
            return false;
        }

        if (/^\d/.test(domain) || /\d$/.test(domain)) {
            toast.error('Domain can not start or end with a number.');
            setLoading(false);
            return false;
        }
        if (!hasDataChanged()) {
            toast.info('No data to update.');
            setLoading(false);
            setIsEditing(false);
            return;
        }
        try {
            const response = await axiosInstance.post(
                `/update-agency-details`, // Replace with your backend endpoint
                data,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            const parsedResponse = JSON.parse(JSON.stringify(response.data));
            const agencyMessage = parsedResponse.message;
            const domainMessage = parsedResponse.domainChangedMessage;
            if (parsedResponse.status === true) {
                toast.success(parsedResponse.message);
                setInputKey(Date.now());
                setLoading(false);
                setIsEditing(false);

                // Update original form data to reflect saved changes
                setOriginalFormData({ ...formData });

                dispatch(setAgency({ agency_id: parsedResponse.data.agency_id }, navigate));
            } else {
                setLoading(false);
                toast.error(parsedResponse.message);
            }
        } catch (error) {
            setLoading(false);
            setFormData({ ...originalFormData });
            setIsEditing(false);
            dispatch(changelayoutMode(originalFormData.layout_theme || layoutTheme.LIGHTMODE, layoutType));
            dispatch(changeTopbarTheme(originalFormData.topbar_theme || topBarThemeTypes.LIGHT));
            console.error("Error updating agency details:", error);
            // toast.error("Something went wrong. Please try again!");
            const errorMessage = (error as any).response?.data?.message || "Something went wrong. Please try again!";
            toast.error(errorMessage);
        }
    };

    //function to handle layout type change
    const handleLayoutThemeChange = (themeValue: string) => {
        if (!isEditing) return; // Prevent change if not editing

        // Update form data
        setFormData(prev => ({
            ...prev,
            layout_theme: themeValue
        }));

        // Dispatch theme change to update UI immediately
        dispatch(changelayoutMode(themeValue, layoutType));
    };

    //function for handling topbar theme change
    const handleTopbarThemeChange = (themeValue: string) => {
        if (!isEditing) return; // Prevent change if not editing
        // Update form data
        setFormData(prev => ({
            ...prev,
            topbar_theme: themeValue
        }));

        // Dispatch theme change to update UI immediately
        dispatch(changeTopbarTheme(themeValue));
    };

    const disabledFieldStyle = {
        backgroundColor: 'transparent',
        border: '1px solid #ced4da',
        cursor: isEditing ? 'text' : 'not-allowed',
        color: 'inherit',
        opacity: isEditing ? 1 : 0.7
    };

    const disabledRadioStyle = {
        backgroundColor: 'transparent',
        cursor: isEditing ? 'pointer' : 'not-allowed',
        color: 'inherit',
        opacity: isEditing ? 1 : 0.7
    };

    const [totalCampaigns, setTotalCampaigns] = useState<number>(0);
    const [runningCampaigns, setRunningCampaigns] = useState<number>(0);
    const [totalMembers, setTotalMembers] = useState<number>(0);

    useEffect(() => {
        const fetchStats = async () => {

            if (agency.data.agency_domain === null) {
                setTotalCampaigns(0);
                setRunningCampaigns(0);
                setTotalMembers(0);
                return;
            }
            try {
                const response = await axiosInstance.get("/dashboard-stats", {
                    params: {
                        agency_id: agency.data.agency_id,
                    },
                });
                const data = response.data;
                setTotalCampaigns(data.totalCampaigns || 0);
                setRunningCampaigns(data.runningCampaigns || 0);
                setTotalMembers(data.members || 0);
            } catch (error) {
                console.error("Error fetching dashboard stats:", error);
            }
        };
        fetchStats();
    }, []);


    return (
        <React.Fragment>
            <div className="page-content" style={{ marginTop: "0" }}>
                <Navbar />
                <Container fluid style={{ maxWidth: "100%", marginTop: 10 }}>
                    <Breadcrumbs title="Settings" breadcrumbItem="Branding" titleLink="/branding" showLeftTitle={false} />
                    <Row className="align-items-stretch h-100">
                        <Col lg={6} className="h-100 d-flex flex-column">
                            <Card className="shadow-none flex-fill">
                                <CardHeader className="justify-content-between d-flex align-items-center">
                                    <h5 className="mb-0"><strong>Overview</strong></h5>
                                </CardHeader>
                                <CardBody className="flex-grow-1 d-flex flex-column">
                                    <form onSubmit={handleSubmit}>
                                        <Col>
                                            <div>
                                                <Row className="mb-3">
                                                    <h5>Update Domain Details</h5>
                                                    <Label htmlFor="example-text-input" className="col-form-label">Name</Label>
                                                    <Col>
                                                        <Input className="form-control"
                                                            type="text"
                                                            name="agency_name"
                                                            value={formData.agency_name}
                                                            onChange={handleChange}
                                                            id="example-text-input"
                                                            maxLength={50}
                                                            style={{
                                                                ...disabledFieldStyle
                                                            }}
                                                            readOnly={!isEditing}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label htmlFor="example-text-input" className="col-form-label">Description</Label>
                                                    <Col>
                                                        <Input
                                                            type="textarea"
                                                            style={{
                                                                maxHeight: "120px",
                                                                minHeight: "120px",
                                                                resize: "none",
                                                                ...disabledFieldStyle
                                                            }}
                                                            className="form-control"
                                                            placeholder="Add agency description..."
                                                            id="floatingTextarea2"
                                                            value={formData.agency_desc}
                                                            name="agency_desc"
                                                            onChange={handleChange}
                                                            maxLength={1000}
                                                            readOnly={!isEditing}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label htmlFor="example-text-input" className="col-form-label">Sub domain</Label>
                                                    <Col>
                                                        <Input
                                                            className="form-control"
                                                            type="text"
                                                            value={formData.agency_domain}
                                                            onChange={handleChange}
                                                            name="agency_domain"
                                                            id="example-text-input"
                                                            style={{
                                                                ...disabledFieldStyle,
                                                                cursor: !agencyData?.Id || !isEditing || !!agency?.data?.agency_domain ? 'not-allowed' : 'text',
                                                                opacity: !agencyData?.Id || !isEditing || !!agency?.data?.agency_domain ? 0.7 : 1
                                                            }}
                                                            readOnly={!agencyData?.Id || !!agency?.data?.agency_domain ? true : !isEditing}
                                                            disabled={!agencyData?.Id || !!agency?.data?.agency_domain}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <h5>Global Settings</h5>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label htmlFor="example-text-input" className="col-form-label">Update Logo</Label>
                                                    <Col>
                                                        <input
                                                            className="form-control"
                                                            type="file"
                                                            id="agency_logo"
                                                            name="agency_logo"
                                                            accept="image/jpeg, image/jpg, image/png"
                                                            onChange={handleChange}
                                                            key={inputKey}
                                                            disabled={!isEditing}
                                                            style={{
                                                                ...disabledFieldStyle
                                                            }}
                                                        />
                                                        <small className="text-muted mt-1">Supported formats: JPG, JPEG, PNG</small>
                                                    </Col>
                                                </Row>
                                                <Row className="mb-1">
                                                    <h5>Website Background</h5>
                                                </Row>

                                                <Row className="mb-2 align-items-center">
                                                    <Label className="col-form-label">Layout Theme</Label>
                                                    <div className="d-flex flex-column  flex-md-row gap-3 ms-2">
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="radioThemeLight"
                                                                name="radioTheme"
                                                                value={layoutTheme.LIGHTMODE}
                                                                className="form-check-input"
                                                                style={{
                                                                    pointerEvents: isEditing ? 'auto' : 'none',
                                                                    cursor: isEditing ? 'pointer' : 'default'
                                                                }}
                                                                disabled={loading}
                                                                checked={formData.layout_theme === layoutTheme.LIGHTMODE}
                                                                onChange={() => isEditing && handleLayoutThemeChange(layoutTheme.LIGHTMODE)}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="radioThemeLight"
                                                                style={{
                                                                    ...disabledRadioStyle,
                                                                    pointerEvents: loading ? "none" : "auto"
                                                                }}
                                                            >
                                                                Light
                                                            </label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="radioThemeDark"
                                                                name="radioTheme"
                                                                value={layoutTheme.DARKMODE}
                                                                className="form-check-input"
                                                                style={{
                                                                    pointerEvents: isEditing ? 'auto' : 'none',
                                                                    cursor: isEditing ? 'pointer' : 'default'
                                                                }}
                                                                disabled={loading}
                                                                checked={formData.layout_theme === layoutTheme.DARKMODE}
                                                                onChange={() => isEditing && handleLayoutThemeChange(layoutTheme.DARKMODE)}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="radioThemeDark"
                                                                style={{
                                                                    ...disabledRadioStyle,
                                                                    pointerEvents: loading ? "none" : "auto"
                                                                }}
                                                            >
                                                                Dark
                                                            </label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="radioThemeGreen"
                                                                name="radioTheme"
                                                                value={layoutTheme.GREENMODE}
                                                                className="form-check-input"
                                                                style={{
                                                                    pointerEvents: isEditing ? 'auto' : 'none',
                                                                    cursor: isEditing ? 'pointer' : 'default'
                                                                }}
                                                                disabled={loading}
                                                                checked={formData.layout_theme === layoutTheme.GREENMODE}
                                                                onChange={() => isEditing && handleLayoutThemeChange(layoutTheme.GREENMODE)}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="radioThemeGreen"
                                                                style={{
                                                                    ...disabledRadioStyle,
                                                                    pointerEvents: loading ? "none" : "auto"
                                                                }}
                                                            >
                                                                Green
                                                            </label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="radioThemeViolet"
                                                                name="radioTheme"
                                                                value={layoutTheme.PURPLEMODE}
                                                                className="form-check-input"
                                                                style={{
                                                                    pointerEvents: isEditing ? 'auto' : 'none',
                                                                    cursor: isEditing ? 'pointer' : 'default'
                                                                }}
                                                                disabled={loading}
                                                                checked={formData.layout_theme === layoutTheme.PURPLEMODE}
                                                                onChange={() => isEditing && handleLayoutThemeChange(layoutTheme.PURPLEMODE)}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="radioThemeViolet"
                                                                style={{
                                                                    ...disabledRadioStyle,
                                                                    pointerEvents: loading ? "none" : "auto"
                                                                }}
                                                            >
                                                                Purple
                                                            </label>
                                                        </div>
                                                    </div>
                                                </Row>

                                                <Row className="mb-2 align-items-center">
                                                    <Label className="col-form-label">Topbar Color</Label>
                                                    <div className="d-flex flex-column  flex-md-row gap-3 ms-2">
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="topbar-color-light"
                                                                name="topbar-color"
                                                                value={topBarThemeTypes.LIGHT}
                                                                className="form-check-input"
                                                                style={{
                                                                    pointerEvents: isEditing ? 'auto' : 'none',
                                                                    cursor: isEditing ? 'pointer' : 'default'
                                                                }}
                                                                disabled={loading}
                                                                checked={topbarTheme === topBarThemeTypes.LIGHT}
                                                                onChange={() => isEditing && handleTopbarThemeChange(topBarThemeTypes.LIGHT)}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="topbar-color-light"
                                                                style={{
                                                                    ...disabledRadioStyle,
                                                                    pointerEvents: loading ? "none" : "auto"
                                                                }}
                                                            >
                                                                Light
                                                            </label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="topbar-color-dark"
                                                                name="topbar-color"
                                                                value={topBarThemeTypes.DARK}
                                                                className="form-check-input"
                                                                style={{
                                                                    pointerEvents: isEditing ? 'auto' : 'none',
                                                                    cursor: isEditing ? 'pointer' : 'default'
                                                                }}
                                                                disabled={loading}
                                                                checked={topbarTheme === topBarThemeTypes.DARK}
                                                                onChange={() => isEditing && handleTopbarThemeChange(topBarThemeTypes.DARK)}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="topbar-color-dark"
                                                                style={{
                                                                    ...disabledRadioStyle,
                                                                    pointerEvents: loading ? "none" : "auto"
                                                                }}
                                                            >
                                                                Dark
                                                            </label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="topbar-color-green"
                                                                name="topbar-color"
                                                                value={topBarThemeTypes.GREEN}
                                                                className="form-check-input"
                                                                style={{
                                                                    pointerEvents: isEditing ? 'auto' : 'none',
                                                                    cursor: isEditing ? 'pointer' : 'default'
                                                                }}
                                                                disabled={loading}
                                                                checked={topbarTheme === topBarThemeTypes.GREEN}
                                                                onChange={() => isEditing && handleTopbarThemeChange(topBarThemeTypes.GREEN)}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="topbar-color-green"
                                                                style={{
                                                                    ...disabledRadioStyle,
                                                                    pointerEvents: loading ? "none" : "auto"
                                                                }}
                                                            >
                                                                Green
                                                            </label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="topbar-color-purple"
                                                                name="topbar-color"
                                                                value={topBarThemeTypes.PURPLE}
                                                                className="form-check-input"
                                                                style={{
                                                                    pointerEvents: isEditing ? 'auto' : 'none',
                                                                    cursor: isEditing ? 'pointer' : 'default'
                                                                }}
                                                                disabled={loading}
                                                                checked={topbarTheme === topBarThemeTypes.PURPLE}
                                                                onChange={() => isEditing && handleTopbarThemeChange(topBarThemeTypes.PURPLE)}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="topbar-color-purple"
                                                                style={{
                                                                    ...disabledRadioStyle,
                                                                    pointerEvents: loading ? "none" : "auto"
                                                                }}
                                                            >
                                                                Purple
                                                            </label>
                                                        </div>
                                                    </div>
                                                </Row>

                                                <hr className="my-3" />
                                                <Row >
                                                    <Col style={{ textAlign: 'right' }}>
                                                        {isEditing ? (
                                                            <Row className="g-2 justify-content-end">
                                                                <Col xs={6} md="auto">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-danger button-secondary w-100"
                                                                        onClick={handleCancelClick}
                                                                        disabled={loading}
                                                                        style={{
                                                                            border: '1px solid #686868',
                                                                            width: '88px',
                                                                            opacity: loading ? 0.6 : 1,
                                                                            cursor: loading ? 'not-allowed' : 'pointer'
                                                                        }}
                                                                    >
                                                                        <i className="mdi mdi-close me-1"></i>
                                                                        Cancel
                                                                    </button>
                                                                </Col>
                                                                <Col xs={6} md="auto">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary button-primary w-100"
                                                                        disabled={loading}
                                                                        onClick={handleSaveClick}
                                                                    >
                                                                        {loading ? (
                                                                            <span className="spinner-border spinner-border-sm"></span>
                                                                        ) : (
                                                                            <>
                                                                                <i className="mdi mdi-content-save me-1"></i>
                                                                                Save
                                                                            </>
                                                                        )}
                                                                    </button>
                                                                </Col>
                                                            </Row>

                                                        ) : (
                                                            <div className="d-grid d-sm-inline">
                                                                <button
                                                                    // color="outline-primary"
                                                                    className="btn button-primary btn-primary"
                                                                    onClick={handleEditClick}
                                                                    style={{
                                                                        width: "auto"
                                                                    }}
                                                                >
                                                                    <i className="mdi mdi-pencil me-1"></i>
                                                                    Edit
                                                                </button>
                                                            </div>
                                                        )}
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </form>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col lg={6} className="d-flex flex-column justify-content-between h-100">
                            <Col>
                                <Card className="flex-fill">
                                    <CardHeader>
                                        <h5 className="mb-0"><strong>Preview Data</strong></h5>
                                    </CardHeader>
                                    <CardBody className="pb-0">
                                        <Row>
                                            <div className="col">
                                                <div className="d-flex align-items-center">
                                                    <div className="flex-shrink-0">
                                                        <div className="avatar">
                                                            <div className="avatar-title bg-primary-subtle text-primary font-size-18 rounded">
                                                                <img src={agency.data.agency_logo} alt="" height="50" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <div className="text-muted">
                                                            <h5 className="font-size-16 mb-1">{agency.data.agency_name}</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Row>
                                        <Row>
                                            {agency?.data?.agency_desc && (
                                                <Col lg={12}>
                                                    <div className="mt-3">
                                                        <ul className="text-muted">
                                                            <li >{agency.data.agency_desc}</li>
                                                        </ul>
                                                    </div>
                                                </Col>
                                            )}

                                            <Col lg={12}>
                                                <Row >
                                                    {/* Domain */}
                                                    <Col lg={12} md={12} className="my-4">
                                                        <label className="d-block text-muted" style={{ marginBottom: "4px" }}>Domain</label>
                                                        <h5 className="font-size-15 mb-0">
                                                            <a
                                                                href={`https://${fullDomain}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className='accent-color'
                                                            >
                                                                {fullDomain}
                                                            </a>
                                                        </h5>
                                                    </Col>

                                                    {/* Layout & Topbar Mode */}
                                                    <Col lg={6} md={12} className="mb-3">
                                                        <div className="d-flex flex-column flex-lg-row justify-content-between gap-4 gap-lg-0">
                                                            <div>
                                                                <label className="d-block" style={{ marginBottom: "4px" }}>Layout Mode</label>
                                                                <div className="text-muted">{layoutMode
                                                                    ? layoutMode.charAt(0).toUpperCase() + layoutMode.slice(1)
                                                                    : ''}</div>
                                                            </div>
                                                            <div className="ms-lg-4">
                                                                <label className="d-block" style={{ marginBottom: "4px" }}>Topbar Mode</label>
                                                                <div className="text-muted">{topbarTheme
                                                                    ? topbarTheme.charAt(0).toUpperCase() + topbarTheme.slice(1)
                                                                    : ''}</div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                                <Card className="flex-fill">
                                    <CardHeader>
                                        <h5 className="mb-0"><strong>Details</strong></h5>
                                    </CardHeader>
                                    <CardBody>
                                        <Row className="gy-4 gy-md-0">
                                            <Col md={4}>
                                                <div className="d-flex align-items-center">
                                                    <div className="flex-shrink-0 me-3">
                                                        <div style={{ width: "38px", height: "38px" }}>
                                                            <div className="avatar-title bg-light text-primary rounded-circle font-size-18">
                                                                <i className="uil uil-bullseye accent-color"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="flex-grow-1 overflow-hidden">
                                                        <label className="d-block" style={{ marginBottom: "4px" }}>Total Campaigns</label>
                                                        <div className="text-muted">{loading ? "..." : totalCampaigns}</div>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={5}>
                                                <div className="d-flex align-items-center">
                                                    <div className="flex-shrink-0 me-3">
                                                        <div style={{ width: "38px", height: "38px" }}>
                                                            <div className="avatar-title bg-light text-primary rounded-circle font-size-18">
                                                                <i className="uil uil-play accent-color"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="flex-grow-1 overflow-hidden">
                                                        <label className="d-block" style={{ marginBottom: "4px" }}>Total Running Campaigns</label>
                                                        <div className="text-muted">{loading ? "..." : runningCampaigns}</div>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div className="d-flex align-items-center">
                                                    <div className="flex-shrink-0 me-3">
                                                        <div style={{ width: "38px", height: "38px" }}>
                                                            <div className="avatar-title bg-light text-primary rounded-circle font-size-18">
                                                                <i className="uil uil-users-alt accent-color"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="flex-grow-1 overflow-hidden">
                                                        <label className="d-block" style={{ marginBottom: "4px" }}>Members</label>
                                                        <div className="text-muted">{loading ? "..." : totalMembers}</div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                                {agencyData?.Id && <CorporateInfo />}
                            </Col>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Branding;
